import type { ParamParseKey, PathMatch } from 'react-router';
import { useMatch, useResolvedPath } from 'react-router';

/**
 * https://github.com/remix-run/react-router/issues/7954
 *
 * Hook to return the match relative to the current route. Does not work like v5 useRouteMatch, which included
 * all params on the route, but only includes params relative to the given pattern
 */
export const useRelativeMatch = <ParamKey extends ParamParseKey<string>>(
    path: string,
): PathMatch<ParamKey> | null => {
    const { pathname } = useResolvedPath(path);

    return useMatch({ path: pathname });
};
